import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PrescriptionDropDown from "../../../../PrescriptionDropdown/PrescriptionDropDown";
import { PrescriprionContext } from "../../../PrintPrescription";
import styles from "./index.module.scss";
import { fetchSpeciality } from "../../../../../actions/SpecialityListingAction";
import { fetch_doctors_v2 } from "../../../../../actions/DoctorListingAction";
import Textarea from 'react-expanding-textarea'

function Referal() {
  const dispatch = useDispatch();
  const [specialities, setSpecialities] = useState([]);
  const [doctors, setDoctors] = useState([]);
  let [referalData, setReferalData] = useState({});
  let [isSpecialityChange, setIsSpecialityChange] = useState(false);
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  const clinicId = "Geri Care";
  const ClinicDetails = JSON.parse(localStorage.getItem("ClinicDetails"));

  useEffect(() => {
    // Fetch speciality data on component load
    dispatch(fetchSpeciality(ClinicDetails?.clinicurl)).then((res) => {
      setSpecialities(res?.data?.data || []);
    });
  }, [dispatch]);

  const handleItemChange = ({ key, value }) => {
    handleWholeData(key, value);

    if (key === "speciality") {
      const selectedSpeciality = specialities.find(
        (item) => item.specialityName === value
      );
      if (selectedSpeciality) {
        // Call fetch_doctors_v2 API when speciality is selected
        fetch_doctors_v2(selectedSpeciality.specialityName, ClinicDetails?.clinicName).then(
          (res) => {
            const { doctorDetails } = res;
            const names = doctorDetails.map((doctor) => doctor.doctorName);
            setDoctors(names);
            console.log("searchDoctor", names);
          }
        );
      }
      setIsSpecialityChange(true);
    } else {
      setIsSpecialityChange(false);
    }
    handleChangeData({ key, value });
  };

  const handleChangeData = ({ key, value }) => {
    setReferalData({ ...referalData, [key]: value });
  };

  return (
    <div className={styles.referal_container}>
      <div className={styles.form}>
        <div className={styles.caption}>Specialty</div>
        <PrescriptionDropDown
          value={wholeData?.speciality}
          onChange={(e) => {
            handleItemChange({ key: "speciality", value: e });
          }}
          defaultPlaceH="Select Specialty"
          DataItem={specialities.map((item) => item.specialityName)}
        />
      </div>

      {wholeData?.speciality ? (
        <div className={styles.form}>
          <div className={styles.caption}>Referral</div>
          <PrescriptionDropDown
            value={isSpecialityChange ? "" : wholeData?.referral}
            onChange={(e) => {
              handleItemChange({ key: "referral", value: e });
            }}
            defaultPlaceH="Select referral"
            DataItem={doctors}
          />
        </div>
      ) : null}

{wholeData?.speciality ? (
        <div className={styles.form}>
          <div className={styles.caption}>Note</div>
          <Textarea
            value={wholeData?.referralNote}
            onChange={(e) => {
              handleItemChange({ key: "referralNote", value: e.target.value });
            }}
            onPaste={(e) => {
              e.preventDefault(); // Prevent default paste behavior
              const pastedData = e.clipboardData.getData("text/plain");
              const start = e.target.selectionStart;
              const end = e.target.selectionEnd;
              const currentValue = e.target.value;

              // Calculate the available space (assuming max length is 200)
              const availableSpace = 200 - (currentValue.length - (end - start));

              // Truncate the pasted data if necessary
              const truncatedPastedData = pastedData.substring(0, availableSpace);

              const newValue =
                currentValue.substring(0, start) +
                truncatedPastedData +
                currentValue.substring(end);

              // Use the existing handleItemChange function to update the state
              handleItemChange({
                key: "referralNote",
                value: newValue.substring(0, 200),
              });

              // Set cursor position after the pasted text
              setTimeout(() => {
                e.target.setSelectionRange(
                  start + truncatedPastedData.length,
                  start + truncatedPastedData.length
                );
              }, 0);
            }}
            className={styles.form_input}
            type="text"
            placeholder="Enter note here"
            maxLength={200}
          />
        </div>
      ) : null}
    </div>
  );
}

export default Referal;
